import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@digdir/designsystemet-react';

import { OppvarmingElektrisk } from '../../../../../../types/registration/userInput';
import {
  AccentedTableRow,
  Capitalize,
  LeftBorderCell
} from '../../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface OppvarmingElektriskProps {
  elektrisk: OppvarmingElektrisk | undefined;
}
export const OppvarmingElektriskView: FC<OppvarmingElektriskProps> = ({ elektrisk }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.tekniskutstyr.oppvarming.elektrisitet' });
  const { t: tCommon } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.common' });

  if (!elektrisk) {
    return null;
  }
  return (
    elektrisk && (
      <Fragment>
        <AccentedTableRow $isSecondarySection>
          <TableCell colSpan={2}>{t('header')}</TableCell>
        </AccentedTableRow>
        {elektrisk.panelovn && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('panelovn.label')}</TableCell>
            </AccentedTableRow>
            {elektrisk.panelovn.installasjonsAr && (
              <TableRow>
                <TableCell>{t('panelovn.installasjonsar')}</TableCell>
                <LeftBorderCell>{elektrisk.panelovn.vetInstallasjonsAr ? elektrisk.panelovn.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: elektrisk.panelovn.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            {elektrisk.panelovn && (
              <TableRow>
                <TableCell>{t('panelovn.termostatstyring.label')}</TableCell>
                <LeftBorderCell>{t(`panelovn.termostatstyring.${elektrisk.panelovn.termostatstyring}`)}</LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}

        {elektrisk.gulvvarme && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('gulvvarme.label')}</TableCell>
            </AccentedTableRow>
            {elektrisk.gulvvarme.installasjonsAr && (
              <TableRow>
                <TableCell>{t('gulvvarme.installasjonsar')}</TableCell>
                <LeftBorderCell>{elektrisk.gulvvarme.vetInstallasjonsAr ? elektrisk.gulvvarme.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: elektrisk.gulvvarme.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>{t('gulvvarme.termostatstyring.label')}</TableCell>
              <LeftBorderCell>{t(`gulvvarme.termostatstyring.${elektrisk.gulvvarme.termostatstyring}`)}</LeftBorderCell>
            </TableRow>
          </Fragment>
        )}

        {elektrisk.luftvarme && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('luftvarme.label')}</TableCell>
            </AccentedTableRow>
            {elektrisk.luftvarme.installasjonsAr && (
              <TableRow>
                <TableCell>{t('luftvarme.installasjonsar')}</TableCell>
                <LeftBorderCell>{elektrisk.luftvarme.vetInstallasjonsAr ? elektrisk.luftvarme.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: elektrisk.luftvarme.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>{t('luftvarme.termostatstyring.label')}</TableCell>
              <LeftBorderCell>{t(`luftvarme.termostatstyring.${elektrisk.luftvarme.termostatstyring}`)}</LeftBorderCell>
            </TableRow>
          </Fragment>
        )}

        {elektrisk.takvarme && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('takvarme.label')}</TableCell>
            </AccentedTableRow>
            {elektrisk.takvarme.installasjonsAr && (
              <TableRow>
                <TableCell>{t('takvarme.installasjonsar')}</TableCell>
                <LeftBorderCell>{elektrisk.takvarme.vetInstallasjonsAr ? elektrisk.takvarme.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: elektrisk.takvarme.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>{t('takvarme.termostatstyring.label')}</TableCell>
              <LeftBorderCell>{t(`takvarme.termostatstyring.${elektrisk.takvarme.termostatstyring}`)}</LeftBorderCell>
            </TableRow>
          </Fragment>
        )}

        {elektrisk.kjel && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('kjel.label')}</TableCell>
            </AccentedTableRow>
            {elektrisk.kjel.installasjonsAr && (
              <TableRow>
                <TableCell>{t('kjel.installasjonsar')}</TableCell>
                <LeftBorderCell>{elektrisk.kjel.vetInstallasjonsAr ? elektrisk.kjel.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: elektrisk.kjel.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            {elektrisk.kjel.bruk && (
              <TableRow>
                <TableCell>{t('kjel.bruk.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.bruk.${elektrisk.kjel.bruk}`)}</LeftBorderCell>
              </TableRow>
            )}
            {elektrisk.kjel.varmesystemBruk && (
              <TableRow>
                <TableCell>{t('kjel.varmesystembruk')}</TableCell>
                <LeftBorderCell><Capitalize>{elektrisk.kjel.varmesystemBruk}</Capitalize></LeftBorderCell>
              </TableRow>
            )}
            {elektrisk.kjel.gulvvarme && (
              <TableRow>
                <TableCell>{t('kjel.gulvvarme.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.gulvvarme.${elektrisk.kjel.gulvvarme}`)}</LeftBorderCell>
              </TableRow>
            )}
            {elektrisk.kjel.radiator && (
              <TableRow>
                <TableCell>{t('kjel.radiator.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.radiator.${elektrisk.kjel.radiator}`)}</LeftBorderCell>
              </TableRow>
            )}
            {elektrisk.kjel.varmesentral && (
              <TableRow>
                <TableCell>{t('kjel.varmesentral.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.varmesentral.${elektrisk.kjel.varmesentral}`)}</LeftBorderCell>
              </TableRow>
            ) &&
              elektrisk.kjel.varmesentralInstallasjonsAr && (
                <TableRow>
                  <TableCell>{t('kjel.varmesentral.varmesentralInstallasjonsAr')}</TableCell>
                  <LeftBorderCell>{elektrisk.kjel.vetVarmesentralInstallasjonsAr ? elektrisk.kjel.varmesentralInstallasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: elektrisk.kjel.varmesentralInstallasjonsAr })}</LeftBorderCell>
                </TableRow>
              )}

            {elektrisk.kjel.serviceGjennomfortSiste2Ar && (
              <TableRow>
                <TableCell>{t('kjel.serviceGjennomfortSiste2Ar')}</TableCell>
                <LeftBorderCell>{t(`kjel.${elektrisk.kjel.serviceGjennomfortSiste2Ar}`)}</LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}

        {elektrisk.elektriskBereder && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('elektriskBereder.label')}</TableCell>
            </AccentedTableRow>
            {elektrisk.elektriskBereder.installasjonsAr && (
              <TableRow>
                <TableCell>{t('elektriskBereder.installasjonsar')}</TableCell>
                <LeftBorderCell>{elektrisk.elektriskBereder.vetInstallasjonsAr ? elektrisk.elektriskBereder.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: elektrisk.elektriskBereder.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  );
};
